import * as React from 'react'

import Wait from "../../wait";
import CollectService from "../../../service/v1/collect";
import AddDodosoPane from "../../add/add_dodoso_pane";
import {generateUUID} from "../../../ug/uuid";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import PopBig from "../../popbig";
import ReadService from "../../../service/read";
import CreateService from "../../../service/create";
import PopDetail from "../../popdetail";
import UploadBackupPane from "../../add/add_zip_backup";
import {arraySearch} from '../../../utils'
import baseUrl from "./../../../service/baseURL";
import DownloadProgressModal from "../../download_progress_modal";

export default class CcroDraftDataPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            current_menu: 0,
            questionnaires: [],
            forms: [],
            forms_all: [],
            analysis: [],

            questions: [],

            village_id: 0,
            answers: [],
            dataview: [
                {name: 'Bar Graph', key: 'bar'},
                {name: 'Pie Chart', key: 'pie'},
                {name: 'Table View', key: 'table'}
            ],
            regions: [],
            districts: [],
            wards: [],
            villages: [],
            hamlets: [],
            parent_id: 0,
            parent_hamlet: 0

        }
        this.loadData = this.loadData.bind(this)
        this.loadQuestionnaires = this.loadQuestionnaires.bind(this)
        this.loadQuestionnairesForms = this.loadQuestionnairesForms.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
        this.changeViewAt = this.changeViewAt.bind(this)
        this.popAddNew = this.popAddNew.bind(this)
    }


    handleSearch = async (e) => {
        let value = e.target.value;
        console.log(this.state.forms_all)
        let search = await arraySearch(this.state.forms_all[0].answers, value);
        console.log('QWERRTYRRYR')
        console.log(search)
        let new_forms;
        new_forms = [{
            id: this.state.forms_all[0].id,
            name: this.state.forms_all[0].name,
            form_fields: this.state.forms_all[0].form_fields,
            answers: search
        }]
        this.setState({
            forms: new_forms,
        })
    }
    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }

    componentDidMount() {
        this.loadLocalities()
        this.loadQuestionnaires()
    }

    popAddNew() {

        /*if(this.state.parent_hamlet<1){
            alert('No Village')
            return
        }*/

        let villagename = ''
        /*this.state.villages.forEach(v=>{
            if(parseInt(v.id)===parseInt(this.state.parent_hamlet)){
                villagename = v.name
            }
        })*/

        PopBig.show('Ongeza Taarifa - ' + villagename,
            <AddDodosoPane project={this.props.project}
                           loadData={() => this.loadQuestionnaires()}
                           uuid={generateUUID()} village={this.state.parent_hamlet} villagename={villagename}
                           questionnaires={this.state.questionnaires}
                           key={new Date().getMilliseconds()}/>)
    }


    loadQuestionnaires() {
        try {
            Wait.show('Fetching Questions')
            CollectService.fetchQuestions(this.props.project.id, this.props.flag === 'analyse' ? 0 : 1).then(r => {
                try {
                    Wait.dismiss()
                    let result = r.data.results
                    let loc = r.data.localities

                    if (loc.regions.length === 1) {
                        this.setState({
                            parent_id: loc.regions[0].id
                        })
                    }
                    this.setState({
                        questionnaires: result,
                        regions: loc.regions,
                        districts: loc.districts,
                        wards: loc.wards,
                        villages: loc.villages,
                        hamlets: loc.hamlets,
                    })
                    /* if (result.length>0){
                         this.loadQuestionnairesForms(result[0].id)
                     }*/
                } catch (e) {
                    Wait.dismiss()
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
            Wait.dismiss()
        }
    }

    loadQuestionnairesForms(form_id, i = 0, j = 0) {
        try {
            if (this.props.flag === 'analyse') {
                Wait.show('Analysing.....')
                CollectService.fetchQuestionsFormsAnalyse(this.props.project.id, form_id).then(r => {
                    try {
                        Wait.dismiss()
                        //console.log(r.data.results)
                        this.setState({
                            analysis: r.data.results,
                            current_menu: i,
                            current_menu_j: j

                        })
                    } catch (e) {
                        console.log(e)
                    }
                })

            } else {
                Wait.show('Fetching Forms....')

                CollectService.fetchQuestionsForms(this.props.project.id, form_id).then(r => {
                    try {
                        Wait.dismiss()
                        console.log(r.data.results)
                        this.setState({
                            forms: r.data.results,
                            forms_all: r.data.results,
                            current_menu: i,
                            current_menu_j: j
                        })
                    } catch (e) {
                        console.log(e)
                    }
                })
            }

        } catch (e) {
            console.log(e)
            Wait.dismiss()
        }
    }

    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        
        const container = {
            width: '100%',
            height: '100vh',
            background: '#f6f8fa',
            fontFamily,
            display: 'flex',
            overflow: 'hidden'
        };
        
        const sidebar = {
            width: '280px',
            background: '#fff',
            borderRight: '1px solid #e0e7ef',
            height: '100vh',
            overflowY: 'auto',
            boxShadow: '2px 0 8px rgba(0,0,0,0.1)'
        };
        
        const sidebarHeader = {
            padding: '20px',
            borderBottom: '1px solid #e0e7ef',
            background: 'linear-gradient(135deg, #395d9a 0%, #2bbbad 100%)',
            color: '#fff'
        };
        
        const sidebarTitle = {
            fontSize: '16px',
            fontWeight: '600',
            marginBottom: '4px'
        };
        
        const sidebarSubtitle = {
            fontSize: '12px',
            opacity: 0.8
        };
        
        const menuItem = {
            padding: '12px 20px',
            cursor: 'pointer',
            borderBottom: '1px solid #f0f0f0',
            transition: 'all 0.2s',
            fontSize: '14px',
            fontWeight: '500'
        };
        
        const activeMenuItem = {
            ...menuItem,
            background: '#395d9a',
            color: '#fff',
            borderLeft: '4px solid #2bbbad'
        };
        
        const subMenuItem = {
            padding: '10px 20px 10px 40px',
            cursor: 'pointer',
            fontSize: '13px',
            color: '#666',
            transition: 'all 0.2s',
            borderBottom: '1px solid #f8f9fa'
        };
        
        const activeSubMenuItem = {
            ...subMenuItem,
            background: '#f8f9fa',
            color: '#395d9a',
            fontWeight: '600',
            borderLeft: '3px solid #2bbbad'
        };
        
        const mainContent = {
            flex: 1,
            padding: '0 24px 24px 24px',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        };
        
        const header = {
            padding: '18px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 18,
            fontWeight: 700,
            color: '#395d9a',
            fontFamily,
            borderBottom: '1px solid #e0e7ef',
            marginBottom: '24px',
            flexShrink: 0
        };
        
        const actionBar = {
            display: 'flex',
            gap: '12px',
            alignItems: 'center',
            marginBottom: '24px',
            flexWrap: 'wrap'
        };
        
        const searchInput = {
            padding: '10px 16px',
            border: '1px solid #e0e7ef',
            borderRadius: 8,
            fontSize: 14,
            fontFamily,
            width: '300px',
            transition: 'border-color 0.2s, box-shadow 0.2s'
        };
        
        const select = {
            padding: '10px 16px',
            border: '1px solid #e0e7ef',
            borderRadius: 8,
            fontSize: 14,
            fontFamily,
            background: '#fff',
            minWidth: '200px'
        };
        
        const btn = {
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '6px 12px',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            minWidth: 'auto'
        };
        
        const btnSecondary = {
            background: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '6px 12px',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            minWidth: 'auto'
        };
        
        const dataCard = {
            background: '#fff',
            borderRadius: 0,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '16px',
            fontFamily,
            marginBottom: '16px',
            border: '1px solid rgba(57,93,154,0.05)',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        };
        
        const cardHeader = {
            fontSize: 16,
            fontWeight: 600,
            color: '#395d9a',
            marginBottom: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            paddingBottom: '8px',
            borderBottom: '2px solid #f0f0f0',
            flexShrink: 0
        };
        
        const tableContainer = {
            overflowX: 'auto',
            overflowY: 'auto',
            borderRadius: 8,
            border: '1px solid #e0e7ef',
            flex: 1,
            maxHeight: 'calc(100vh - 280px)'
        };
        
        const table = {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: 14
        };
        
        const tableHeader = {
            background: '#f8f9fa',
            padding: '8px 12px',
            textAlign: 'left',
            fontSize: 14,
            fontWeight: 600,
            color: '#395d9a',
            borderBottom: '2px solid #e0e7ef'
        };
        
        const tableCell = {
            padding: '8px 12px',
            fontSize: 14,
            color: '#333',
            borderBottom: '1px solid #f0f0f0'
        };
        
        const analysisCard = {
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '24px',
            fontFamily,
            marginBottom: '24px',
            border: '1px solid rgba(57,93,154,0.05)'
        };
        
        const viewToggle = {
            display: 'flex',
            gap: '8px',
            marginBottom: '20px'
        };
        
        const viewBtn = {
            padding: '6px 12px',
            border: '1px solid #e0e7ef',
            borderRadius: 0,
            background: '#fff',
            cursor: 'pointer',
            fontSize: 12,
            fontWeight: 500,
            transition: 'all 0.2s',
            minWidth: 'auto'
        };
        
        const activeViewBtn = {
            ...viewBtn,
            background: '#395d9a',
            color: '#fff',
            borderColor: '#395d9a'
        };
        
        return (
            <div style={container}>
                <div style={sidebar}>
                    <div style={sidebarHeader}>
                        <div style={sidebarTitle}>
                            <span className={'fa fa-list'} style={{marginRight: 8}}/>
                            {this.props.flag === 'analyse' ? 'Analysis' : 'Questionnaires'}
                        </div>
                        <div style={sidebarSubtitle}>
                            {this.state.questionnaires.length} categories available
                        </div>
                    </div>

                    {this.state.questionnaires.map((d, i) => (
                        <div key={i}>
                            <div style={i === this.state.current_menu ? activeMenuItem : menuItem}>
                                {d.name}
                            </div>
                            <div>
                                {d.forms.map((f, j) => (
                                    <div 
                                        key={j}
                                        style={j === this.state.current_menu_j && i === this.state.current_menu ? activeSubMenuItem : subMenuItem}
                                        onClick={() => this.loadQuestionnairesForms(f.id, i, j)}
                                    >
                                        {f.name}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
                
                <div style={mainContent}>
                    <div style={header}>
                        <span>
                            <span className={'fa fa-database'} style={{marginRight: 12}}/>
                            {this.props.flag === 'analyse' ? 'Data Analysis' : 'Data Collection'}
                        </span>
                        
                        <div style={{display: 'flex', gap: '12px', alignItems: 'center'}}>
                            <input 
                                name={'search'} 
                                onChange={this.handleSearch}
                                style={searchInput}
                                placeholder={'Search data...'}
                            />
                            
                            <select 
                                name={'village'} 
                                style={select}
                                onChange={this.handleChanges}
                            >
                                <option value={undefined}>- Choose Village -</option>
                                {this.state.villages.map((d, i) => (
                                    <option value={d.id} key={i}>{d.name}</option>
                                ))}
                            </select>
                            
                            <button style={btnSecondary} onClick={() => PopDetail.show('Upload Backup File', <UploadBackupPane project={this.props.project} key={new Date().getMilliseconds()}/>)}>
                                <span className={'fa fa-upload'}/>Upload Backup
                            </button>
                            
                            <button style={{...btnSecondary, background: 'linear-gradient(90deg, #fd7e14 0%, #e8590c 100%)', color: 'white'}} onClick={() => this.previewParcels()}>
                                <span className={'fa fa-eye'}/>View
                            </button>
                            
                            <button style={btn} onClick={() => this.downloadSHP()}>
                                <span className={'fa fa-download'}/>Download .SHP
                            </button>
                        </div>
                    </div>
                    
                    {this.props.flag !== 'analyse' ? (
                        this.state.forms.map((d, i) => (
                            <div key={i} style={dataCard}>
                                <div style={cardHeader}>
                                    <span className={'fa fa-question-circle'} style={{color: '#395d9a'}}/>
                                    {d.name}
                                </div>
                                
                                <div style={tableContainer}>
                                    <table style={table}>
                                        <thead>
                                        <tr>
                                                <th style={tableHeader}>#</th>
                                                {d.form_fields.map((q, j) => (
                                                    <th style={tableHeader} key={j}>{q.form_field}</th>
                                                ))}
                                        </tr>
                                        </thead>
                                        <tbody>
                                            {d.answers.map((a, k) => (
                                                <tr key={k}>
                                                    <td style={tableCell}>{k + 1}.</td>
                                                    {a.row.map((r, l) => (
                                                        <td style={tableCell} key={l}>{r.answer}</td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                
                                <div style={{marginTop: '16px'}}>
                                    <button style={btnSecondary}>
                                            <span className={'fa fa-print'}/>Export
                                        </button>
                                    </div>
                            </div>
                        ))
                    ) : (
                        this.state.analysis.map((d, i) => (
                            <div key={i} style={analysisCard}>
                                <div style={cardHeader}>
                                    <span className={'fa fa-chart-bar'} style={{color: '#395d9a'}}/>
                                    {d.name}
                                </div>
                                
                                <div style={viewToggle}>
                                    {this.state.dataview.map((v, j) => (
                                        <button
                                            key={j}
                                            style={j === 0 ? activeViewBtn : viewBtn}
                                            onClick={() => this.changeViewAt(d, v, i, j)}
                                        >
                                            <span className={'fa fa-' + (v.key === 'bar' ? 'bar-chart' : v.key === 'pie' ? 'pie-chart' : 'table')} style={{marginRight: 6}}/>
                                            {v.name}
                                        </button>
                                    ))}
                                </div>
                                
                                        <div id={'bar_' + d.id + '_' + i}>
                                            <HighchartsReact
                                                highcharts={Highcharts}
                                                options={this.loadBarChart(d)}
                                            />
                                        </div>

                                        <div id={'pie_' + d.id + '_' + i} style={{display: 'none'}}>
                                            <HighchartsReact
                                                highcharts={Highcharts}
                                                options={this.loadPieChart(d)}
                                            />
                                        </div>
                                
                                        <div id={'table_' + d.id + '_' + i} style={{display: 'none'}}>
                                    <div style={tableContainer}>
                                        <table style={table}>
                                                <thead>
                                                <tr>
                                                    <th style={tableHeader}>DataSet</th>
                                                    {d.categories.map((c, k) => (
                                                        <th style={tableHeader} key={k}>{c}</th>
                                                    ))}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {d.series.map((s, l) => (
                                                    <tr key={l}>
                                                        <td style={tableCell}>{s.name}</td>
                                                        {s.data.map((c, m) => (
                                                            <td style={tableCell} key={m}>{c}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                    </div>
                                        </div>

                                <div style={{marginTop: '16px'}}>
                                    <button style={btn}>
                                                <span className={'fa fa-print'}/>Export
                                            </button>
                                        </div>
                                    </div>
                        ))
                    )}
                </div>
            </div>
        )
    }

    changeViewAt(d, v, i, j) {
        this.state.analysis.map((dd, ii) => {
            this.state.dataview.map((ss, jj) => {
                document.getElementById('btn_' + ii + '_' + jj).style.background = 'inherit'
                document.getElementById('btn_' + ii + '_' + jj).style.fontWeight = 'inherit'
                document.getElementById('btn_' + ii + '_' + jj).style.color = 'inherit'
            })
        })
        document.getElementById('btn_' + i + '_' + j).style.background = '#484848'
        document.getElementById('btn_' + i + '_' + j).style.fontWeight = 'bold'
        document.getElementById('btn_' + i + '_' + j).style.color = '#fff'


        switch (v.key) {
            case "pie":
                document.getElementById('pie_' + d.id + '_' + i).style.display = 'inherit'
                document.getElementById('bar_' + d.id + '_' + i).style.display = 'none'
                document.getElementById('table_' + d.id + '_' + i).style.display = 'none'
                break
            case "bar":
                document.getElementById('bar_' + d.id + '_' + i).style.display = 'inherit'
                document.getElementById('pie_' + d.id + '_' + i).style.display = 'none'
                document.getElementById('table_' + d.id + '_' + i).style.display = 'none'
                break
            case "table":
                document.getElementById('table_' + d.id + '_' + i).style.display = 'inherit'
                document.getElementById('pie_' + d.id + '_' + i).style.display = 'none'
                document.getElementById('bar_' + d.id + '_' + i).style.display = 'none'
                break
        }
    }

    loadPieChart(d) {
        //console.log(d)
        return {
            chart: {
                renderTo: 'high-chart-donut0',
                type: 'pie'
            },
            title: {
                text: d.name,
            },
            yAxis: {
                title: {
                    text: 'Total percent market share'
                }
            },
            plotOptions: {
                pie: {
                    shadow: true
                }
            },
            tooltip: {
                formatter: function () {
                    return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
                }
            },
            series: [{
                name: 'LandUse',
                data: d.data,//[["Agriculture", 40], ["Settlement", 30], ["Forest", 10], ["Investment", 15], ["Reserve", 5]],
                size: '100%',
                innerSize: '10%',
                showInLegend: true,
                dataLabels: {
                    enabled: true
                }
            }]
        }

    }

    loadBarChart(d) {
        //console.log(d)
        return {
            chart: {
                type: 'column'
            },

            title: {
                text: d.name
            },

            subtitle: {
                text: ''
            },

            yAxis: {
                title: {
                    text: 'No. of Project'
                }
            },

            xAxis: {
                categories: d.categories,//['Selemi', 'Buduba'],
                crosshair: true
            },

            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle'
            },
            series: d.series,
            /*series: [{
                    name: 'Ndio',
                    data: [631, 727]
                }, {
                    name: 'Hapana',
                    data: [814, 841]
                }],*/




            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            }
        }
    }

    loadData() {
        try {
            Wait.show('Fetching Draft Data....')
            ReadService.fetchCCRDraftData(this.props.project.id, this.state.village, this.props.flag).then(r => {
                Wait.dismiss()
                try {
                    console.log(r.data)
                    this.setState({
                        questions: r.data.questions,
                        answers: r.data.answers
                    })
                } catch (e) {
                    console.log(e)
                }

            })
        } catch (e) {
            console.log(e)
        }
    }

    loadLocalities() {
        /* try{
             Wait.show('Loading Villages...')
             ReadService.fetchLocalitiesByProject(this.props.project.id).then(r=>{
                 try {
                     let data = r.data.results

                     console.log(data)
                     this.setState({
                         villages:data,
                         village_id:data[0].id
                     })

                     setTimeout(()=>this.loadData(),500)
                 }catch (e) {
                     console.log(e)
                 }


             })
         }catch (e) {
             console.log(e)
         }*/

    }

    downloadSHP() {
        try {
            let village_id = parseInt(this.state.village)

            if (village_id === undefined) {
                alert('Please select a village first')
                return
            }
            
            try {
                // Show the download progress modal
                try {
                    if (window.DownloadProgressModal && typeof window.DownloadProgressModal.show === 'function') {
                        window.DownloadProgressModal.show('Tafadhali kuwa Mvumilivu. Panaweza kuchukua muda mrefu kiasi. kutokana na uwingi wa taarifa...')
                    } else {
                        console.warn('DownloadProgressModal not available, using Wait.show');
                        Wait.show('Tafadhali kuwa Mvumilivu. Panaweza kuchukua muda mrefu kiasi. kutokana na uwingi wa taarifa...')
                    }
                } catch (error) {
                    console.error('Error showing download modal:', error);
                    Wait.show('Tafadhali kuwa Mvumilivu. Panaweza kuchukua muda mrefu kiasi. kutokana na uwingi wa taarifa...')
                }
                
                CreateService.downloadSHP({
                    project_id: this.props.project.id,
                    village_id: village_id
                }).then(r => {

                    let pollCount = 0;
                    const maxPolls = 300; // 10 minutes max (300 * 2 seconds)
                    
                    let refreshIntervalId = setInterval(() => {
                        pollCount++;
                        
                        // Check for timeout
                        if (pollCount > maxPolls) {
                            clearInterval(refreshIntervalId);
                            if (window.DownloadProgressModal) {
                                window.DownloadProgressModal.update(0, 'Error', 'Download timeout. Please try again.')
                                setTimeout(() => {
                                    window.DownloadProgressModal.dismiss()
                                }, 3000)
                            } else {
                                Wait.dismiss()
                            }
                            return;
                        }
                        
                        CreateService.askDownloadSHPStatus(r.data.task_id).then(d => {
                            let data = d.data
                            let progression = data.progression || 0
                            let state = data.state || 'Processing'

                            console.log('Download progress:', progression, 'State:', state, 'Poll count:', pollCount);

                            // Update the modal with progress
                            if (window.DownloadProgressModal) {
                                window.DownloadProgressModal.update(progression, state, `Tafadhali Subiri....${progression}% => ${state}`)
                            }

                            // Check for completion (progress > 96%)
                            if (progression > 96.0) {
                                clearInterval(refreshIntervalId)
                                if (window.DownloadProgressModal) {
                                    window.DownloadProgressModal.update(100, 'Completed', 'Inamalizia....100%')
                                    
                                    setTimeout(() => {
                                        window.DownloadProgressModal.dismiss()
                                        window.open(baseUrl().split("/api")[0]+`/downloads/${r.data.locality_name}`, '_blank');
                                    }, 2000)
                                } else {
                                    Wait.dismiss()
                                    window.open(baseUrl().split("/api")[0]+`/downloads/${r.data.locality_name}`, '_blank');
                                }
                                return;
                            }

                            // Check for failure states
                            if (state === 'FAILURE' || state === 'REVOKED' || state === 'REJECTED') {
                                clearInterval(refreshIntervalId)
                                if (window.DownloadProgressModal) {
                                    window.DownloadProgressModal.update(0, 'Error', 'Download failed. Please try again.')
                                    setTimeout(() => {
                                        window.DownloadProgressModal.dismiss()
                                    }, 3000)
                                } else {
                                    Wait.dismiss()
                                }
                                return;
                            }

                            // Check for completion state
                            if (state === 'SUCCESS' && progression >= 100) {
                                clearInterval(refreshIntervalId)
                                if (window.DownloadProgressModal) {
                                    window.DownloadProgressModal.update(100, 'Completed', 'Download completed successfully!')
                                    
                                    setTimeout(() => {
                                        window.DownloadProgressModal.dismiss()
                                        window.open(baseUrl().split("/api")[0]+`/downloads/${r.data.locality_name}`, '_blank');
                                    }, 2000)
                                } else {
                                    Wait.dismiss()
                                    window.open(baseUrl().split("/api")[0]+`/downloads/${r.data.locality_name}`, '_blank');
                                }
                                return;
                            }

                            // Continue polling if still processing
                            if (state === 'PENDING' || state === 'STARTED' || state === 'PROGRESS') {
                                // Continue polling
                                return;
                            }

                        }).catch(error => {
                            console.error('Error checking download status:', error);
                            clearInterval(refreshIntervalId)
                            if (window.DownloadProgressModal) {
                                window.DownloadProgressModal.update(0, 'Error', 'Download failed. Please try again.')
                                setTimeout(() => {
                                    window.DownloadProgressModal.dismiss()
                                }, 3000)
                            } else {
                                Wait.dismiss()
                            }
                        })
                    }, 2000)

                                            // Store the interval ID for cleanup (not needed with simple modal)

                }).catch(error => {
                    if (window.DownloadProgressModal) {
                        window.DownloadProgressModal.update(0, 'Error', 'Failed to start download. Please try again.')
                        setTimeout(() => {
                            window.DownloadProgressModal.dismiss()
                        }, 3000)
                    } else {
                        Wait.dismiss()
                    }
                })
            } catch (e) {
                console.log(e)
                if (window.DownloadProgressModal) {
                    window.DownloadProgressModal.update(0, 'Error', 'An error occurred. Please try again.')
                    setTimeout(() => {
                        window.DownloadProgressModal.dismiss()
                    }, 3000)
                } else {
                    Wait.dismiss()
                }
            }
        } catch (e) {
            console.log(e)
            if (window.DownloadProgressModal) {
                window.DownloadProgressModal.update(0, 'Error', 'An error occurred. Please try again.')
                setTimeout(() => {
                    window.DownloadProgressModal.dismiss()
                }, 3000)
            } else {
                Wait.dismiss()
            }
        }
    }

    previewParcels() {
        try {
            let village_id = parseInt(this.state.village)

            if (village_id === undefined) {
                alert('Please select a village first')
                return
            }

            // Get the stage from the loaded data - using the first form's stage if available
            let stage = '';
            if (this.state.forms && this.state.forms.length > 0 && this.state.forms[0].stage) {
                stage = this.state.forms[0].stage;
            }

            Wait.show('Loading parcels preview...')
            
            // Construct the direct URL for the parcels map
            const parcelsMapUrl = `${baseUrl()}/collect/ccro/parcels/map?village_id=${village_id}&stage=${stage}`;
            
            // Open the URL directly in a new tab
            const newWindow = window.open(parcelsMapUrl, '_blank');
            
            if (!newWindow) {
                alert('Please allow popups for this site to view the parcels preview');
            }
            
            Wait.dismiss()
            
        } catch (e) {
            Wait.dismiss()
            console.error('Error in previewParcels:', e);
            alert('Error loading parcels preview. Please try again.');
        }
    }

}